import React, { useEffect } from "react";
import "../css/style.css";

function ServiceIntro() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="service-intro-section">
      <div className="container text-center">
        <p className="service-intro-text fade-up">
          <strong>Quality Cleaning Services You Can Trust</strong> 
     
          
         Our professional cleaning services are designed to make your home healthier, fresher, and more comfortable without any stress. We provide high-quality, reliable, and affordable cleaning solutions tailored to your daily needs, using safe products and modern cleaning techniques. From complete home cleaning that removes dust and allergens, to deep kitchen cleaning that eliminates grease and bacteria, and thorough bathroom cleaning that ensures hygiene and freshness, our trained team focuses on every detail with care and precision. We are committed to delivering consistent results, maintaining cleanliness standards, and ensuring customer satisfaction through dependable service, timely execution, and attention to hygiene in every corner of your home.
        </p>
      </div>
    </section>
  );
}

export default ServiceIntro;
